import { UseStylesProps } from './types'

const APP_MAIN_MENU_HEIGHT = 64
const APP_OPTION_MENU_HEIGHT = 64
const APP_MENU_MARGIN_HEIGHT = 16
export const APP_MENU_HEIGHT =
  APP_MAIN_MENU_HEIGHT + APP_OPTION_MENU_HEIGHT + APP_MENU_MARGIN_HEIGHT

export const paddingBottomValue = ({
  canShowActionBar,
  quantityOfButtonsInActionBar,
  isPhone,
}: Pick<
  UseStylesProps,
  'canShowActionBar' | 'quantityOfButtonsInActionBar' | 'isPhone'
>) => {
  if (canShowActionBar && isPhone) {
    return `${64 * quantityOfButtonsInActionBar}px`
  } else if (canShowActionBar && !isPhone) {
    return '74px'
  }
  return '0'
}
